var accFaqs = document.getElementsByClassName("faqs-accordion");
var i;

for (i = 0; i < accFaqs.length; i++) {
  accFaqs[i].addEventListener("click", function() {
    // Close all accordions
    for (var j = 0; j < accFaqs.length; j++) {
      if (accFaqs[j] != this) {
        accFaqs[j].classList.remove("active");
        accFaqs[j].nextElementSibling.style.maxHeight = null;
      }
    }

    // Toggle the clicked accordion
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}
  
document.addEventListener("DOMContentLoaded", function() {
  accFaqs[0].click();
});

window.addEventListener("load", function() {
  var ingredientCarousel = document.querySelector('.ingredient-carousel');
  ingredientCarousel.style.display = 'block';
  var ingredientFlickity = new Flickity( ingredientCarousel, {
    // options
    cellAlign: 'left',
    draggable: true,
    wrapAround: true,
    imagesLoaded: true,
    pageDots: false
  });
});

var inputElement = document.getElementById("variant-62675977437553");
  if (inputElement) {
    inputElement.click();
  } else {
    console.error("Input element not found!");
  }
  const buyOptionBox = document.querySelector('.buy-option-box[data-ptype="subscribe"] label');
  const selectElement = document.getElementById('data-product-subscription-2');
  selectElement.style.display = 'block';

  

  function selectVariant(variantId, bottleNo) {

    console.log("Selected bottleNo:", bottleNo);
    
    // Get the price of the selected variant
    var price = document.getElementById("variant-" + variantId).getAttribute("data-price");
    // Calculate the discounted price
    var discountedPrice = price * 0.80;
    var perbottlePrice = Math.floor((price / bottleNo) * 100) / 100;
    var perbottlePriceSub = (price * 0.80) / bottleNo;
    // Update the displayed prices
    document.getElementById("one-time-price").innerHTML = "$" + price + " ($" + perbottlePrice + " per bottle)";
    document.getElementById("subscription-price").innerHTML = "$" + discountedPrice.toFixed(2) + " ($" + perbottlePriceSub.toFixed(2) + " per bottle)";

     // Update the hidden input with the selected variant ID
    document.querySelector('input[name="id"]').value = variantId;

var discountBar = document.getElementById("discount-bar");
    if (bottleNo == 1) {
        discountBar.innerHTML = "$29.97 + $7.95 Shipping";
    } else if (bottleNo == 2) {
        discountBar.innerHTML = "10% OFF - SAVE $10";
    } else if (bottleNo == 3) {
        discountBar.innerHTML = "Buy 2, Get 1 Free - Save $29.97!";
    }


    var priceContainer = document.querySelector('.price-container');
    var oldPrice = priceContainer.querySelector('.old-price');
    var newPrice = priceContainer.querySelector('.new-price');

    if (bottleNo == 1) {
        oldPrice.style.display = 'none'; // Hide old price
        newPrice.innerHTML = "$29.97 + $7.95 Shipping";
    } else if (bottleNo == 2) {
        oldPrice.style.display = 'inline'; // Show old price
        oldPrice.innerHTML = "$99.94";
        newPrice.innerHTML = "$89.94 + Free Shipping";
    } else if (bottleNo == 3) {
        oldPrice.style.display = 'inline'; // Show old price
        oldPrice.innerHTML = "$89.91";
        newPrice.innerHTML = "$59.94 + $7.95 Shipping";
    }

    
    
    // Remove "active" class from all images
    var images = document.querySelectorAll('.product-img');
    images.forEach(function(image) {
      image.classList.remove('active');
    });
    
    // Add "active" class to the selected image
    var imgElements = document.querySelectorAll('img.product-img');
    imgElements.forEach(function(img) {
      var variant = img.getAttribute('data-variant');
      if (variant == variantId) {
        img.classList.add('active');
      }
    });
  }





  

  function addToCart() {
    var form = document.getElementById('ProductForm-{{ product.id }}');
    var selectedVariant = form.querySelector('input[name="id"]:checked');
    if (!selectedVariant) {
      alert("Please select a variant.");
      return;
    }
    // Submit the form
    form.submit();
  }
  
  window.addEventListener('load', function() {
    var buyOptionBoxes = document.querySelectorAll(".buy-option-box");
    var subvariantoption = document.querySelectorAll('label[for="variant-62675977372017"]');
    const subscriptionOptions = document.getElementById("data-product-subscription-2");
    var sellingPlanInput = document.getElementById('sellingPlanInput');
    for (var i = 0; i < buyOptionBoxes.length; i++) {
      buyOptionBoxes[i].addEventListener("click", function() {
        var pType = this.getAttribute("data-ptype");
        var buyBoxInput = this.querySelector('input');
        if (buyBoxInput) {
          buyBoxInput.click();
        }
        if (pType === 'one-time') {
          subscriptionOptions.style.display = "none";
          sellingPlanInput.value = '';
          document.querySelectorAll('.truezs-variant-button .btn').forEach(function(button) {
            const dataPrice = parseFloat(button.getAttribute('data-price'));
            const dataQuantity = parseInt(button.getAttribute('data-quantity'));
            const bottlePrice = (dataPrice / dataQuantity);
            const savingsPrice = (49.97 * dataQuantity) - (dataPrice);
            const totalPrice = dataPrice;
            const bottlePriceElement = button.querySelector('.bottle-price');
            const savingsPriceElement = button.querySelector('.bottle-savings');
            const totalPriceElement = button.querySelector('.total-price');
            if (bottlePriceElement) {
              bottlePriceElement.textContent = bottlePrice.toFixed(2);
            }
            if (savingsPriceElement) {
              savingsPriceElement.textContent = savingsPrice.toFixed(2);
            }
            totalPriceElement.textContent = totalPrice.toFixed(2);
          });
        } else {
          subscriptionOptions.style.display = "block";
          sellingPlanInput.value = '{{ firstSubscriptionOption }}';
          document.querySelectorAll('.truezs-variant-button .btn').forEach(function(button) {
            const dataPrice = parseFloat(button.getAttribute('data-price'));
            const dataQuantity = parseInt(button.getAttribute('data-quantity'));
            const bottlePrice = (dataPrice / dataQuantity) * 0.80;
            const savingsPrice = (49.97 * dataQuantity) - (dataPrice * 0.80);
            const totalPrice = dataPrice * 0.80;
            const bottlePriceElement = button.querySelector('.bottle-price');
            const savingsPriceElement = button.querySelector('.bottle-savings');
            const totalPriceElement = button.querySelector('.total-price');
            if (bottlePriceElement) {
              bottlePriceElement.textContent = bottlePrice.toFixed(2);
            }
            if (savingsPriceElement) {
              savingsPriceElement.textContent = savingsPrice.toFixed(2);
            }
            totalPriceElement.textContent = totalPrice.toFixed(2);
          });
        }
      });
    }
    subscriptionOptions.addEventListener("change", function() {
      var selectedValue = subscriptionOptions.value;
      sellingPlanInput.value = selectedValue;
    });
    buyOptionBoxes[0].click();
  });
  